import axios from './axios';

export const locationsAPI = {
  getAll: async () => {
    const response = await axios.get('/locations/');
    return response.data;
  },

  getTree: async () => {
    const response = await axios.get('/locations/tree');
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/locations/${id}`);
    return response.data;
  },

  getAncestors: async (id) => {
    const response = await axios.get(`/locations/${id}/ancestors`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/locations/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`/locations/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/locations/${id}`);
    return response.data;
  }
};
